import React from 'react';
import getTradingCompanyName from '../../../../utils/getTradingCompanyName';
import { LANGUAGE } from '../../../../constants';
import type { OptionsType } from '../../../../types/options';
import type { InformationType } from '../../../../types/information';

interface InformationItemProps {
  information: InformationType;
  tradingCompany: OptionsType[];
}

const InformationItem = ({ information, tradingCompany }: InformationItemProps): React.ReactElement => {
  const nameJa: string = getTradingCompanyName(information.tradingCompanyCode, { tradingCompanies: tradingCompany, language: LANGUAGE.JA });
  const nameEn: string = getTradingCompanyName(information.tradingCompanyCode, { tradingCompanies: tradingCompany, language: LANGUAGE.EN });

  // SIDE EFFECT
  // ================================================================================

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <span className="trading-company-item">
      【{nameJa}／{nameEn}】{information.message}
    </span>
  );
};
export default InformationItem;
